<div
    style="background-color: white; width: 100%; max-width: auto; height: auto; display: flex; flex-direction: column; align-items: center; padding: 40px;">
    <div style="width: 100%; display: flex; justify-content: flex-end;">
        <img (click)="closeDialog()" onKeyDown="" src="../../../assets/icons/gray_close.svg" alt=""
            style="width: 16px; height: 16px; cursor: pointer;">
    </div>
    @if(isError || isWarning){
    <img src="../../../assets/icons/warning-icon.svg" alt="" style="width: 45px; height: 45px; margin: 17px 0 16px 0;">
    }
    <p class="info-title text-center" style="margin-bottom: 0px!important;" *ngIf="message!=''" [innerHTML]="message"></p>
    <div style="width: 100%;text-align: left!important;font-size: 16px;">
        <div style="width: 100%; text-align: left; font-size: 16px;">

        <div style="max-height: 200px; overflow-y: auto;">
            <ul style="text-align: left;" class="list-group list-group-flush">
                <li *ngFor="let restriccion of data.listRestricciones" class="list-group-item list-group-item-light">
                    <i class="fa fa-circle text-secondary me-2" style="font-size: 8px; vertical-align: middle;" aria-hidden="true"></i>{{ restriccion.mensajeRestriccion }}
                </li>
            </ul>
        </div>

        </div>

    </div>
    <!-- <button (click)="closeDialog()" class="info-cancel-btn">{{ isError?'Regresar':'Continuar'}}</button> -->
    <button *ngIf="!isWithRestricciones" (click)="closeDialog()" class="btn btn-primary mt-4">{{
        isError?'Regresar':'Enterado'}}</button>

    <ng-container *ngIf="isWithRestricciones">
        <div class="d-flex justify-content-center gap-2 mt-3">
            <button (click)="closeDialog()" class="btn btn-default">
                Cancelar
            </button>

            <button (click)="save()" class="btn btn-primary">
                Guardar
            </button>
        </div>
    </ng-container>

    <ng-container *ngIf="isListadoRestricciones">
        <div class="d-flex justify-content-center gap-2 mt-3">
            <button (click)="closeDialog()" class="btn btn-default">
                Cerrar
            </button>
        </div>
    </ng-container>

</div>